import qs from 'qs';
import dotToPath from 'helpers/dotToPath';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const EducationProgramsEndPoint = {
  dataURL: 'education/programs',
  sourceName: 'educationProgramsList',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters = {}, sort, search, groupBy }) => {
    const { name, ...restFilters } = filters;
    const normalizedFilters = { ...restFilters };

    const urlData = {
      filters: dotToPath(normalizedFilters),
      sort
    };

    if (search) {
      urlData.filters.search = search;
    }

    if (groupBy) {
      urlData.groupBy = groupBy;
    }

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    const { meta, data } = payload;
    const { limit, count, offset } = meta || {};
    const payloadData = data || payload;

    return {
      data: concat ? (state.data || []).concat(payloadData) : payloadData,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      // Preserve existing count if API didn't return one (subsequent pages)
      count: count ?? state.count
    };
  }
};

export default EducationProgramsEndPoint;
